import { Button, Link, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { Icons } from '../../../assets/icons';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import React from 'react';

const SampleFileForDownload = () => {
  const downloadFile = (fileName: string) => {
    const link = document.createElement('a');
    link.href = `/sample-file/${fileName}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {/* <Stack spacing={2} direction="column">
          <Button variant="contained" onClick={() => downloadFile('Bulk_Address_Upload_AS_CSV.csv')}>
            Bulk Address Upload AS CSV
          </Button>
          <Button variant="contained" onClick={() => downloadFile('Bulk_Address_Upload_AS_Excel.xlsx')}>
            Bulk Address Upload AS Excel
          </Button>
          <Button variant="contained" onClick={() => downloadFile('Bulk_Lot_Upload_AS_CSV.csv')}>
            Bulk Lot Upload AS CSV
          </Button>
          <Button variant="contained" onClick={() => downloadFile('Bulk_Lot_Upload_AS_Excel.xlsx')}>
            Bulk Lot Upload AS Excel
          </Button>
        </Stack> */}
      {/* <Stack spacing={2} direction="column" alignItems="center">
          <Typography variant="h6" gutterBottom textAlign="center">
            Download Sample Files
          </Typography>
          <Link component="button" variant="body1" onClick={() => downloadFile('Bulk_Address_Upload_AS_CSV.csv')}>
            <img src={Icons.poDownload} alt="notes" /> Bulk Address Upload AS CSV
          </Link>
          <Link component="button" variant="body1" onClick={() => downloadFile('Bulk_Address_Upload_AS_Excel.xlsx')}>
            <img src={Icons.Excel} alt="excel" /> Bulk Address Upload AS Excel
          </Link>
          <Link component="button" variant="body1" onClick={() => downloadFile('Bulk_Lot_Upload_AS_CSV.csv')}>
            <img src={Icons.poDownload} alt="notes" /> Bulk Lot Upload AS CSV
          </Link>
          <Link component="button" variant="body1" onClick={() => downloadFile('Bulk_Lot_Upload_AS_Excel.xlsx')}>
            <img src={Icons.Excel} alt="excel" /> Bulk Lot Upload AS Excel
          </Link>
        </Stack> */}
      <div>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          variant="outlined"
          className="btn btn-outline-primary btnIcon"
          style={{ marginRight: 8 }}
        >
          Download Template
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem
            onClick={() => {
              downloadFile('Bulk_Address_Upload_AS_CSV.csv');
              handleClose();
            }}
          >
            <img src={Icons.FileDownload} alt="notes" style={{ marginRight: '2px', marginLeft: '-4px' }} /> Bulk Address
            Upload AS CSV
          </MenuItem>
          <MenuItem
            onClick={() => {
              downloadFile('Bulk_Address_Upload_AS_Excel.xlsx');
              handleClose();
            }}
          >
            <img src={Icons.Excel} alt="excel" style={{ marginRight: '5px' }} /> Bulk Address Upload AS Excel
          </MenuItem>
          <MenuItem
            onClick={() => {
              downloadFile('Bulk_Lot_Upload_AS_CSV.csv');
              handleClose();
            }}
          >
            <img src={Icons.FileDownload} alt="notes" style={{ marginRight: '2px', marginLeft: '-4px' }} /> Bulk Lot
            Upload AS CSV
          </MenuItem>
          <MenuItem
            onClick={() => {
              downloadFile('Bulk_Lot_Upload_AS_Excel.xlsx');
              handleClose();
            }}
          >
            <img src={Icons.Excel} alt="excel" style={{ marginRight: '5px' }} /> Bulk Lot Upload AS Excel
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default SampleFileForDownload;
